import { Col, Divider, Form, Pagination, Row, Spin } from 'antd'
import Flex from 'components/Flex'

import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons'
import InputNumber from 'components/Form/InputNumber'
import RadioButton from 'components/Form/Radio'
import SelectField from 'components/SelectField/SelectField'
import TreeSelect from 'components/TreeSelect'
import FilterCheckBoxComp from 'components/UIElements/FilterCheckBoxComp/FilterCheckBoxComp'
import FilterChipComponent from 'components/UIElements/FilterChipComponent'
import EmptyStateImage from 'components/icons/EmptyState'
import MyLocation from 'components/icons/MyLocation.png'
import SearchIcon from 'components/icons/SearchIcon'
import SingleListed from 'modules/Roles/Style/singleListed'
import {
  AnchorText,
  CompType,
  CompTypeInside,
  ContentCenterDiv,
  FilterHeadDiv,
  FilterText,
  FilterTitle,
  InputNumberPadding,
  RadioGroups,
  RangeText,
  RedNote,
  RightDivCol,
  SearchInput,
  SectionWrapper,
  ShowNum,
  SpinWrapper,
  StyleLeft,
  TopHeader,
  TopHeading,
} from 'modules/Roles/Style/style'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import BlacklistMessageComponent from '../Dashboard/Style/BlackListComponent'
import SalaryRanges from './Style/CompType'
import ExceptionBrand from './Style/ExceptionBrand'

const Roles = ({
  ApplyRole,
  SaveRole,
  getRolesList,
  rolesList,
  getSingleRoleDetails,
  updateRoleFloatDetails,
  singleRoleDetails,
  getEligibleDetails,
  getRoleFloatDetails,
  getFunctionsList,
  getCities,
  collegeData,
  studentDetails,
  functionsList,
  updateStudentData,
  getStudentData,
  getListOfSkills,
  getRoleCities,
  citiesRoleList,
  getStudentRoleList,
  getCompTypeList,
  getSkillLocationFilterData,
  studentData,
  getStudentRuleSet,
  updateStudent,
  getNewRoleMetrics,
  optoutStatus,
  rejectStudentStatus,
  studentOptedStatus,
}) => {
  const object = useRef()
  const [form] = Form.useForm()
  const [page, setPage] = useState(0)
  const [sortValue, setSortValue] = useState('')
  const [search, setSearch] = useState('')
  const [jobType, setJobType] = useState([])
  const [locationFilter, setLocationFilter] = useState([])
  const [minCTC, setMinCTC] = useState(null)
  const [maxCTC, setMaxCTC] = useState(null)

  const [loading, setLoading] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)

  const [roleCitiesData, setRoleCitiesData] = useState([])
  const searchCity = ''
  const [debounced, setDebounced] = useState(() => search)
  const [showModal, setShowModal] = useState(false)
  const [showCompType, setShowCompType] = useState(false)
  const [showBrand, setShowBrand] = useState(false)
  const [roleTypeFilter, setRoleTypeFilter] = useState([])
  const [roleListData, setRoleListData] = useState([])
  const [expLevelFilter, setExpLevelFilter] = useState([])
  const [workStyleFilter, setWorkStyleFilter] = useState([])
  const [empTypeFilter, setEmpTypeFilter] = useState([])
  const [locationList, setLocationList] = useState([])
  const [skillsList, setSkillsList] = useState([])
  const [exceptionBrand, setExceptionBrand] = useState([])
  const [roleTypewithComp, setRoleTypeWithComp] = useState([])
  const [allRoles, setAllRoles] = useState(false)
  const [skillsFilter, setSkillsFilter] = useState([])
  const [locationsFilter, setLocationsFilter] = useState([])
  const [ctcError, setCTCError] = useState(false)
  const [ctcType, setCtcType] = useState('')
  const [showExp, setshowExp] = useState([])
  const [noStipend, setNoStipend] = useState([])
  const [tpoStatus, setTPOStatus] = useState([])
  const [studentRules, setStudentRules] = useState(null)
  const [studentFullRules, setStudentFullRules] = useState(null)

  const RadioOptions = [
    {
      id: 1,
      label: 'PA',
      value: 'PA',
    },
    {
      id: 2,
      label: 'PM',
      value: 'PM',
    },
  ]
  const RadioOptions1 = [
    {
      id: 1,
      label: 'My Roles',
      value: false,
    },
    {
      id: 2,
      label: 'All Roles',
      value: true,
    },
  ]
  const typeList = [
    {
      id: 1,
      label: 'On rolls',
      value: 'ONROLL',
    },
    {
      id: 2,
      label: 'Off rolls / Contractual',
      value: 'CONTRACT',
    },
  ]
  const jobTypeList = [
    {
      id: 1,
      label: 'Placements',
      value: 'PLACEMENT',
    },
    {
      id: 2,
      label: 'Internship',
      value: 'INTERNSHIP',
    },
    {
      id: 3,
      label: 'Gigs',
      value: 'GIGS',
    },
    {
      id: 4,
      label: 'Apprenticeship',
      value: 'APPRENTICESHIP',
    },
  ]
  const expLevelList = [
    {
      id: 1,
      label: 'Freshers',
      value: 'ENTRY',
    },
    {
      id: 2,
      label: 'Experienced',
      value: 'EXPERIENCED',
    },
    {
      id: 3,
      label: 'Both',
      value: 'BOTH',
    },
  ]

  const workStyleList = [
    {
      id: 1,
      label: 'Full Time',
      value: 'FULL_TIME',
    },
    {
      id: 2,
      label: 'Part Time',
      value: 'PART_TIME',
    },
    {
      id: 3,
      label: 'Hybrid',
      value: 'HYBRID',
    },
    {
      id: 4,
      label: 'Remote',
      value: 'REMOTE',
    },
    {
      id: 5,
      label: 'Onsite',
      value: 'ONSITE',
    },
  ]
  const statusOptions = [
    { label: 'Newest First', value: 'newest' },
    { label: 'Oldest First', value: 'oldest' },
    { label: 'Last week', value: 'last_week' },
    { label: 'Last 30 days', value: 'last_30_days' },
    { label: 'Salary - High to Low', value: 'salary_high_to_low' },
    { label: 'Salary - Low to High', value: 'salary_low_to_high' },
    { label: 'Show only Bookmarked', value: 'show_bookmarked' },
  ]

  const filterFunction = (skills, locations) => {
    // Process skills array
    const skillsLabels = skills?.map((skill, index) => ({
      label: `Skills - ${skill?.name}`, // Assuming each skill has a 'name' property
      indices: {
        skillsIndex: index,
      },
    }))

    // Process locations array
    const locationLabels = locations?.map((location, index) => ({
      label: `Location - ${location?.name}`, // Assuming each location object also has a 'name' property
      indices: {
        locationIndex: index,
      },
    }))

    // Combine both arrays
    return [...skillsLabels, ...locationLabels]
  }
  console.log(locationFilter, 'locationFiletr')
  const filterArr = filterFunction(skillsFilter, locationsFilter)
  const handleRemoveFilter = filterItem => {
    const { skillsIndex, locationIndex } = filterItem.indices
    if (skillsIndex !== undefined) {
      setSkillsFilter(
        skillsFilter.filter((item, index) => index !== skillsIndex)
      )
    } else if (locationIndex !== undefined) {
      setLocationsFilter(
        locationsFilter.filter((item, index) => index !== locationIndex)
      )
    }
  }
  const filterByNewest = [
    {
      value: 'showAll',
      title: 'Show All',
      children: [
        { value: 'APPROVED', title: 'Show all applied' },
        { value: 'PENDING', title: 'TPO appr. Pending' },
        { value: 'DECLINED', title: 'TPO appr. Declined' },
        { value: 'LAPSED', title: 'TPO appr. Lapsed' },
      ],
    },
  ]

  const handleShowFilterClick = () => {
    if (showModal) {
      setShowModal(false)
    } else {
      setShowModal(true)
    }
  }
  const onChangeRoleType = checkedvalue => {
    setRoleTypeFilter(checkedvalue)
  }
  const onChangeJobType = checkedvalue => {
    setJobType(checkedvalue)
  }

  const onChangeExpType = checkedvalue => {
    setExpLevelFilter(checkedvalue)
  }

  const onChangeWorkType = checkedvalue => {
    setWorkStyleFilter(checkedvalue)
  }
  const onChangeEmpType = checkedvalue => {
    setEmpTypeFilter(checkedvalue)
  }

  const handleMenuClick = value => {
    let sortValue = ''

    switch (value) {
      case 'newest':
        sortValue = 'sort=posted_date&orderBy=desc'
        break
      case 'oldest':
        sortValue = 'sort=posted_date&orderBy=asc'
        break
      case 'salary_high_to_low':
        sortValue = 'sort=max_compensation&orderBy=desc'
        break
      case 'salary_low_to_high':
        sortValue = 'sort=max_compensation&orderBy=asc'
        break
      case 'last_week':
        sortValue = 'fromDate=7'
        break
      case 'last_30_days':
        sortValue = 'fromDate=30'
        break
      case 'show_bookmarked':
        sortValue = 'saved=1'
        break
      default:
        break
    }

    setSortValue(sortValue) // Update the state or context with this new value
  }

  useEffect(() => {
    fetchRoleListData()
  }, [page])

  useEffect(() => {
    getNewRoleMetrics()
    studentOptedStatus()
  }, [])

  useEffect(() => {
    setPage(0)
    fetchRoleListData()
  }, [
    search,
    jobType,
    expLevelFilter,
    workStyleFilter,
    empTypeFilter,
    allRoles,
    skillsFilter,
    locationsFilter,
    ctcType,
    roleTypeFilter,
    showExp,
    noStipend,
    sortValue,
    tpoStatus,
    studentRules,
    studentFullRules,
  ])
  useEffect(() => {
    if (minCTC >= 0 && maxCTC >= 0 && maxCTC > minCTC) {
      setCTCError(false)
      fetchRoleListData()
    }
    if (minCTC >= 0 && maxCTC >= 0 && maxCTC < minCTC) {
      setCTCError(true)
    }
  }, [minCTC, maxCTC])
  useEffect(() => {
    fetchInitialComType()
    fetchInitialSkillLocation()
  }, [])

  useEffect(() => {
    fetchStudentRuleSet()
  }, [])

  const fetchStudentRuleSet = async () => {
    let result = await getStudentRuleSet()
    setStudentRules(result?.data?.data?.offerLimit)
    setStudentFullRules(result?.data?.data)
  }
  const fetchInitialComType = async () => {
    let result = await getCompTypeList()
    setExceptionBrand(result?.data?.data?.instituteRule?.brands?.list)
    setRoleTypeWithComp(
      result?.data?.data?.instituteRule?.compensationThreshold?.isEnabled
        ? result?.data?.data?.instituteRule?.compensationThreshold
            ?.compensationList
        : []
    )
  }
  const fetchInitialSkillLocation = async () => {
    let result = await getSkillLocationFilterData()
    const resultDataEmpty = transformArray(result?.data?.data?.locations)

    // Assuming `setLocationList` is a function to set the transformed data
    setLocationList(resultDataEmpty)
    // setLocationList(result?.data?.data?.locations)
    
    // Deduplicate skills by id to prevent duplicate entries in dropdown
    const skillsData = result?.data?.data?.skills || []
    const uniqueSkills = skillsData.filter((skill, index, self) => 
      index === self.findIndex((s) => s.id === skill.id)
    )
    setSkillsList(uniqueSkills)
  }

  function transformArray(data) {
    // Check if data is not empty
    if (!data || data?.length === 0) {
      return [] // Return an empty array if data is undefined or has no elements
    }

    // Check if any element has `isAnyWhere` key and is true
    const hasIsAnyWhere = data?.some(item => item.isAnyWhere)

    // Filter out objects that only have isAnyWhere: false
    const filteredData = data?.filter(item => {
      if (
        !item.isAnyWhere &&
        Object.keys(item).length === 1 &&
        'isAnyWhere' in item
      ) {
        return false
      }
      return !item.isAnyWhere
    })

    // Add a new object with id and name set to 'isAnyWhere' if needed
    if (hasIsAnyWhere) {
      filteredData.unshift({ id: 'isAnyWhere', name: 'Anywhere' })
    }

    return filteredData.map(item => ({
      name: item.name || item.state_name,
      id: item.id || item.state_id,
    }))
  }
  function parseSortValue(sortStr) {
    return sortStr?.split('&')?.reduce((acc, param) => {
      let [key, value] = param.split('=')
      if (key && value) {
        if (key === 'fromDate') {
          acc[key] = Number(value)
        } else {
          acc[key] = value
        }
      }
      return acc
    }, {})
  }

  const fetchRoleListData = async () => {
    setLoading(true)
    let sortParams = sortValue ? parseSortValue(sortValue) : {}
    let payLoad = {
      pageLimit: 10,
      pageNo: page,
      searchBy: search,
      jobCategory: jobType?.toString(),
      jobTypeLevels: expLevelFilter?.toString(),
      workStyle: workStyleFilter?.toString(),
      employmentType: empTypeFilter?.toString(),
      isAllRole: allRoles,
      // ctcType: ctcType,
      packageType: roleTypeFilter, //packageType need to send order
      tpoStatus: tpoStatus,
      noStipend: noStipend?.length > 0 ? true : false,
      ...sortParams,
    }
    const skillIds = skillsFilter?.map(item => item.id).filter(id => id)
    if (skillIds?.length) {
      payLoad.skillIds = skillIds
    }

    // Check if any object has the isAnywhere property set to true
    const isAnywhere = locationsFilter?.some(item => item.id === 'isAnyWhere')

    // Set payLoad.isAnywhere based on the presence of isAnywhere

    console.log(isAnywhere, locationsFilter, 'isAnywhere')
      const locationIds = locationsFilter
      ?.filter(item => item.id !== 'isAnyWhere')
      ?.map(item => item.id)
      ?.filter(id => id)
    
    if (isAnywhere) {
      payLoad.isAnyWhere = true
    } else {
      payLoad.isAnyWhere = false
    }
    
    if (locationIds?.length) {
      payLoad.locationIds = locationIds
    }

    const corporateIds = exceptionBrand?.map(item => item?.corporateId)
    if (showExp?.length > 0) {
      payLoad.exceptionalBrands = corporateIds
    } else {
      delete payLoad.exceptionalBrands
    }
    if (studentRules) {
      payLoad.multiplesAmount = studentRules?.multiplesAmount
      payLoad.absoluteAmount = studentRules?.absoluteAmount
      payLoad.compensationMinAmount = studentRules?.compensationMinAmount
      payLoad.compensationLimitReached = studentRules?.compensationLimitReached
      payLoad.exceptionalBrandsThreshold =
        studentRules?.exceptionalBrandsThreshold
    }
    if (studentRules?.isOfferRuleActive)
      payLoad.isOfferRuleActive = studentRules?.isOfferRuleActive

    if (form.getFieldValue('maxCTC') > form.getFieldValue('minCTC')) {
      payLoad.minCTC = form.getFieldValue('minCTC')
      payLoad.maxCTC = form.getFieldValue('maxCTC')
    }

    let result = await getStudentRoleList(payLoad)
    setRoleListData(result?.data?.data || [])
    setLoading(false)
  }

  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }
  const searchValue = value => {
    setSearch(value)
  }
  const delaySaveToDb = useCallback(
    debounce(val => {
      searchValue(val)
    }, 1000),
    []
  )
  const UpdatedSkills = () => {
    fetchRoleListData()
  }

  const handleChange = e => {
    delaySaveToDb(e.target.value)
  }

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const onPageChange = key => {
    setPage(key - 1)
    ScrollRef()
  }

  useEffect(() => {
    getStudentData()
  }, [])

  useEffect(() => {
    if (locationFilter?.length > 0) {
      setPage(0)
    }
  }, [locationFilter])

  const ShowText = () => {
    const currentPage = page + 1
    const currentCount = currentPage * 10
    if (roleListData?.count === 0) {
      return 'Showing ' + roleListData?.count + ' of ' + roleListData?.count
    } else if (currentPage === roleListData?.totalPage) {
      return 'Showing ' + roleListData?.count + ' of ' + roleListData?.count
    } else {
      return 'Showing ' + currentCount + ' of ' + roleListData?.count
    }
  }
  // const forMap = tag => {
  //   const tagElem = (
  //     <StyledTag
  //       closable
  //       onClose={e => {
  //         e.preventDefault()
  //         handleClose(tag)
  //       }}
  //     >
  //       {tag}
  //     </StyledTag>
  //   )
  //   return (
  //     <span
  //       key={tag}
  //       style={{
  //         display: 'inline-block',
  //       }}
  //     >
  //       {tagElem}
  //     </span>
  //   )
  // }
  // const tagChild = initialFilter?.map(forMap)

  const handleTPOStatusChange = (value, label, extra) => {
    let selectedItem = []
    const selectedNodeProps = extra.triggerNode.props
    if (selectedNodeProps?.value == 'showAll') {
      selectedItem = selectedNodeProps?.children?.map(item => item.props?.value)
    } else {
      selectedItem = value
    }
    setTPOStatus(selectedItem)
  }
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(searchCity)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchCity])

  React.useEffect(() => {
    setRoleCitiesData([])
    getRoleCities({ setLoadingCity: setLoadingCity })
  }, [debounced])

  useEffect(() => {
    if (citiesRoleList?.result?.length) {
      let list = citiesRoleList?.result
        ?.map(val => {
          return {
            label: val?.name,
            value: val?.name,
            count: val?.count,
          }
        })
        .filter(option => option?.label)

      let newList = [...roleCitiesData, ...list]
      setRoleCitiesData(newList)
    }
  }, [citiesRoleList?.result])

  const clearData = () => {
    setPage(0)
    setMinCTC(0)
    setMaxCTC(0)
    form.setFieldValue('minCTC', null)
    form.setFieldValue('maxCTC', null)
    setRoleTypeFilter([])
    setshowExp([])
    setNoStipend([])
    setJobType([])
    setWorkStyleFilter([])
    setExpLevelFilter([])
    setEmpTypeFilter([])
    setLoading(true)

    clearCall()
  }

  const clearCall = () => {
    fetchRoleListData()
  }
  const handleRoleChange = event => {
    setAllRoles(event.target.value)
  }
  const handleCTCTypeChange = event => {
    setCtcType(event.target.value)
  }
  const clearLocationData = () => {
    setLocationFilter([])
  }
  const toggleCompType = () => {
    setShowCompType(!showCompType)
  }
  const toggleBrand = () => {
    setShowBrand(!showBrand)
  }

  const handleSkillChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props
    const output = value?.map((id, index) => ({
      id: id,
      name: label[index],
      origin: 'Skills',
    }))
    setSkillsFilter(output)
  }

  // const handleLocationChange = (value, label, extra) => {
  //   const selectedNodeProps = extra.triggerNode.props
  //   const output = value?.map((id, index) => ({
  //     id: id,
  //     name: label[index],
  //     origin: 'Location',
  //   }))
  //   setLocationsFilter(output)
  // }

  // const handleLocationChange = (value, label, extra) => {
  //   const selectedNodeProps = extra.triggerNode.props

  //   const output = value?.map((id, index) => ({
  //     id: selectedNodeProps?.id,
  //     name: selectedNodeProps?.name,
  //     state_id: selectedNodeProps?.state_id,
  //     state_name: selectedNodeProps?.state_name,
  //   }))
  //   setLocationsFilter(output)
  // }
  const handleLocationChange = (value, label, extra) => {
    {
      console.log(value, label, extra, 'onChange')
    }
    const selectedNodeProps = extra.triggerNode.props
    const output = value?.map((id, index) => ({
      id: id,
      name: label[index],
      origin: 'Location',
    }))
    setLocationsFilter(output)
  }
  return (
    <SectionWrapper column>
      <Row>
        <Col span={6}>
          <>
            {roleTypewithComp?.length > 0 && (
              <>
                <CompType
                  onClick={() => toggleCompType()}
                  margin="0px 20px 8px 20px"
                >
                  Know about Comp. Type{' '}
                  {showCompType ? (
                    <CaretDownOutlined />
                  ) : (
                    <CaretRightOutlined />
                  )}
                </CompType>
                {showCompType && (
                  <CompTypeInside>
                    <SalaryRanges roleTypewithComp={roleTypewithComp} />
                  </CompTypeInside>
                )}
              </>
            )}
          </>
          <>
            {exceptionBrand?.length > 0 && (
              <>
                <CompType onClick={toggleBrand} margin="0px 20px 8px 20px">
                  Know about Exceptional Brands{' '}
                  {showBrand ? <CaretDownOutlined /> : <CaretRightOutlined />}
                </CompType>
                {showBrand && (
                  <CompTypeInside>
                    <ExceptionBrand companies={exceptionBrand} />
                  </CompTypeInside>
                )}
              </>
            )}
          </>
          <StyleLeft>
            <Flex row spaceBetween style={{ paddingTop: '5px' }}>
              <TopHeading flexStart style={{ paddingTop: '5px' }}>
                <FilterText>Filter</FilterText>
              </TopHeading>
              <TopHeading flexEnd>
                <AnchorText onClick={clearData} color={true}>
                  Clear all
                </AnchorText>
              </TopHeading>
            </Flex>
            <Divider style={{ margin: '14px 0' }} />
            <Flex row spaceBetween>
              <TopHeading flexStart>
                <FilterTitle>CTC Range</FilterTitle>
              </TopHeading>
              {/* <TopHeading flexEnd>
                <RadioGroup onChange={handleCTCTypeChange} value={ctcType}>
                  {RadioOptions?.map((item, index) => (
                    <Radio
                      key={index + 'options'}
                      border={true}
                      label={item?.label}
                      value={item?.value}
                    />
                  ))}
                </RadioGroup>
              </TopHeading> */}
            </Flex>
            <InputNumberPadding>
              <Form form={form}>
                <RangeText>From</RangeText>
                <Flex alignCenter>
                  <Form.Item
                    style={{ marginBottom: '2px' }}
                    name="minCTC"
                    rules={[
                      {
                        validator: (_, value) => {
                          console.log(value, 'valid')

                          if (value > 20000000) {
                            return Promise.reject(
                              new Error(
                                'Value must be lesser than or equal to 2 crores'
                              )
                            )
                          }

                          return Promise.resolve()
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      addonBefore="₹"
                      width={'230px'}
                      radius={'0px 8px 8px 0px'}
                      value={minCTC}
                      parser={value => value.replace(/\D/g, '')} // Remove all non-digits
                      formatter={
                        value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') // Format the displayed value
                      }
                      onKeyPress={event => {
                        if (!/\d/.test(event.key)) {
                          event.preventDefault()
                        }
                      }}
                      onChange={value => {
                        console.log(value)
                        // Force the value to stay within the range
                        const numericValue = Number(value)
                        if (numericValue > 20000000) {
                          setMinCTC(20000000) // Set to max if over 20 million
                        } else {
                          setMinCTC(numericValue) // Otherwise, update normally
                        }
                      }}
                    />
                  </Form.Item>
                  &nbsp;{' - '}
                </Flex>
                <RangeText>To</RangeText>
                <Flex alignCenter>
                  <Form.Item
                    style={{ marginBottom: '2px' }}
                    name="maxCTC"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value > 20000000) {
                            return Promise.reject(
                              new Error(
                                'Value must be lesser than or equal to 2 crores'
                              )
                            )
                          }
                          // if(minCTC >= maxCTC){
                          //   return Promise.reject(new Error('To CTC Need to Greater than From CTC'));
                          // }
                          return Promise.resolve()
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      addonBefore="₹"
                      width={'230px'}
                      radius={'0px 8px 8px 0px'}
                      name="maxCTC"
                      parser={value => value.replace(/[^0-9]/g, '')}
                      onKeyPress={event => {
                        // Prevent input if the key pressed is not a digit
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault()
                        }
                      }}
                      defaultValue={maxCTC}
                      onChange={e => {
                        if (e <= 20000000) setMaxCTC(e)
                      }}
                      disabled={minCTC >= 0 && minCTC != null ? false : true}
                      formatter={value =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      }
                    />
                  </Form.Item>
                </Flex>
              </Form>
            </InputNumberPadding>

            {ctcError && (
              <InputNumberPadding>
                <RedNote>To CTC must be greater than From CTC</RedNote>
              </InputNumberPadding>
            )}
            <FilterHeadDiv>
              <InputNumberPadding>
                <FilterCheckBoxComp
                  padding="8px 10px !important"
                  options={[
                    {
                      label: 'No Stipend',
                      value: 'No Stipend',
                    },
                  ]}
                  value={noStipend}
                  onChange={newShowExp => {
                    setNoStipend(newShowExp) // Update state based on checkbox
                  }}
                  labelParam="label"
                  valueParam="label"
                />
              </InputNumberPadding>
            </FilterHeadDiv>
            <FilterHeadDiv>
              {roleTypewithComp?.length > 0 && (
                <>
                  <FilterTitle>Role Type</FilterTitle>
                  <InputNumberPadding>
                    <FilterCheckBoxComp
                      padding="8px 10px !important"
                      options={roleTypewithComp}
                      value={roleTypeFilter}
                      onChange={onChangeRoleType}
                      labelParam="name"
                      valueParam="orderNo"
                    />
                  </InputNumberPadding>
                </>
              )}
              {exceptionBrand?.length > 0 && (
                <FilterHeadDiv>
                  <InputNumberPadding>
                    <FilterCheckBoxComp
                      padding="8px 10px !important"
                      options={[
                        {
                          label: 'Show Exceptional Brands',
                          value: 'Show Exceptional Brands',
                        },
                      ]}
                      weight={700}
                      value={showExp}
                      onChange={newShowExp => {
                        setshowExp(newShowExp) // Update state based on checkbox
                      }}
                      labelParam="label"
                      valueParam="label"
                    />
                  </InputNumberPadding>
                </FilterHeadDiv>
              )}

              <FilterHeadDiv>
                <FilterTitle>Job Type</FilterTitle>
                <InputNumberPadding>
                  <FilterCheckBoxComp
                    padding="8px 10px !important"
                    options={jobTypeList}
                    value={jobType}
                    onChange={onChangeJobType}
                    labelParam="label"
                    valueParam="value"
                  />
                </InputNumberPadding>
              </FilterHeadDiv>

              <FilterHeadDiv>
                <FilterTitle>Work Style</FilterTitle>
                <InputNumberPadding>
                  <FilterCheckBoxComp
                    padding="8px 10px !important"
                    options={workStyleList}
                    value={workStyleFilter}
                    onChange={onChangeWorkType}
                    labelParam="label"
                    valueParam="value"
                  />
                </InputNumberPadding>
              </FilterHeadDiv>

              <FilterHeadDiv>
                <FilterTitle>Experience Level</FilterTitle>
                <InputNumberPadding>
                  <FilterCheckBoxComp
                    padding="8px 10px !important"
                    options={expLevelList}
                    value={expLevelFilter}
                    onChange={onChangeExpType}
                    labelParam="label"
                    valueParam="value"
                  />
                </InputNumberPadding>
              </FilterHeadDiv>

              <FilterHeadDiv>
                <InputNumberPadding>
                  <FilterCheckBoxComp
                    padding="8px 10px !important"
                    options={typeList}
                    value={empTypeFilter}
                    onChange={onChangeEmpType}
                    labelParam="label"
                    valueParam="value"
                  />
                </InputNumberPadding>
              </FilterHeadDiv>
            </FilterHeadDiv>
          </StyleLeft>
        </Col>

        <RightDivCol span={18} ref={object}>
          <TopHeader row spaceBetween alignCenter padding={'20px 20px'}>
            <TopHeading flexStart>Roles</TopHeading>
          </TopHeader>
          <TopHeader
            row
            spaceBetween
            alignCenter
            padding={'0px 20px'}
            gap={'10px'}
          >
            <TopHeading flexStart>
              <SearchInput
                width={'417px'}
                height={'48px'}
                onChange={handleChange}
                placeholder="Search by keyword"
                suffix={<SearchIcon />}
              />{' '}
              &nbsp; &nbsp;
              <TreeSelect
                style={{ marginTop: '-4px' }}
                width={'200px'}
                showArrow={true}
                filterTreeNode={false}
                treeData={filterByNewest}
                treeCheckable={true}
                placeholder="TPO Statuses"
                maxTagCount={0}
                placeholderSize={'16px'}
                showSearch={false}
                onChange={handleTPOStatusChange}
                treeDefaultExpandAll={true}
                removeTreeIndent={true}
                placeholderStyle
                white
                // onSearch={data => handleDepartmentSearch(data)}
                height={'48px'}
                //   value={selectedDepartment}
                treeNodeFilterProp="title"
                autoClearSearchValue={false}
                listHeight={180}
                // allowClear={isEditRoleOnView ? false : true}
              />
              &nbsp; &nbsp;
              <SelectField
                style={{ borderRadius: '5px', width: '200px', height: '48px' }}
                showArrow={true}
                options={statusOptions}
                valueParam="value"
                placeholder="Status"
                onChange={handleMenuClick}
                showSearch={false}
                allowClear={true}
                selectedPlaceId={'sortByEvent'}
              />
            </TopHeading>
          </TopHeader>

          <TopHeader row spaceBetween alignCenter padding={'5px 20px'}>
            <TopHeading flexStart gap={'5px'}>
              <TreeSelect
                width={'258px'}
                showArrow={true}
                valueParam="id"
                titleParam="name"
                treeData={skillsList}
                treeCheckable={true}
                placeholder="Search by skills"
                maxTagCount={0}
                placeholderSize={'16px'}
                showSearch={true}
                onChange={handleSkillChange}
                treeDefaultExpandAll={true}
                removeTreeIndent={true}
                placeholderStyle
                value={skillsFilter?.map(item => item.id) || []}
                white
                // onSearch={data => handleDepartmentSearch(data)}
                height={'48px'}
                treeNodeFilterProp="name"
                autoClearSearchValue={false}
                listHeight={180}
                filterTreeNode={(input, node) =>
                  node.props.title.toLowerCase().includes(input.toLowerCase())
                }
              />
              &nbsp; &nbsp;
              <TreeSelect
                valueParam="id"
                titleParam="name"
                width={'262px'}
                showArrow={true}
                treeData={locationList}
                treeCheckable={true}
                placeholder="Search by Location"
                maxTagCount={0}
                placeholderSize={'16px'}
                showSearch={true}
                onChange={handleLocationChange}
                treeDefaultExpandAll={true}
                removeTreeIndent={true}
                placeholderStyle
                white
                // onSearch={data => handleDepartmentSearch(data)}
                height={'48px'}
                value={locationsFilter?.map(item => item.id) || []}
                treeNodeFilterProp="name"
                autoClearSearchValue={false}
                listHeight={180}
                filterTreeNode={(input, node) =>
                  node.props.title.toLowerCase().includes(input.toLowerCase())
                }
                suffixIcon={<img src={MyLocation} />}
              />
              &nbsp; &nbsp;
              <RadioGroups onChange={handleRoleChange} value={allRoles}>
                {RadioOptions1?.map((item, index) => (
                  <RadioButton
                    radioWidth={'auto'}
                    key={index + item?.value}
                    border={true}
                    label={item?.label}
                    value={item?.value}
                  />
                ))}
              </RadioGroups>
            </TopHeading>
          </TopHeader>
          <TopHeader row spaceBetween alignCenter padding={'10px 20px'}>
            <FilterChipComponent
              data={filterArr || []}
              handleClick={handleShowFilterClick}
              open={showModal}
              handleRemoveFilter={handleRemoveFilter}
            />
            <TopHeading flexEnd>
              <ShowNum>{ShowText()}</ShowNum>
            </TopHeading>
          </TopHeader>

          <BlacklistMessageComponent
            studentDetails={studentData}
            optOutStatus={optoutStatus}
            onAction={rejectStudentStatus}
          />
          {/* <FilterChipPanel>{tagChild}</FilterChipPanel> */}

          {loading ? (
            <SpinWrapper center>
              <Spin />
            </SpinWrapper>
          ) : (
            <SingleListed
              DataList={roleListData}
              ApplyRole={ApplyRole}
              SaveRole={SaveRole}
              getSingleRoleDetails={getSingleRoleDetails}
              getEligibleDetails={getEligibleDetails}
              getFunctionsList={getFunctionsList}
              singleRoleDetails={singleRoleDetails}
              getRoleFloatDetails={getRoleFloatDetails}
              collegeData={collegeData}
              studentDetails={studentDetails}
              functionsList={functionsList}
              updateStudentData={updateStudentData}
              getListOfSkills={getListOfSkills}
              updateRoleFloatDetails={updateRoleFloatDetails}
              UpdatedSkills={UpdatedSkills}
              getRolesList={getRolesList}
              studentData={studentData}
              fetchRoleListData={fetchRoleListData}
              roleTypewithComp={roleTypewithComp}
              updateStudent={updateStudent}
              studentFullRules={studentFullRules}
              exceptionBrand={exceptionBrand}
              fetchStudentRuleSet={fetchStudentRuleSet}
              optOutStatus={optoutStatus}
            />
          )}

          {roleListData?.result?.length === 0 ? (
            <>
              <ContentCenterDiv>
                <EmptyStateImage />
              </ContentCenterDiv>
              <ContentCenterDiv>No Data Found</ContentCenterDiv>
            </>
          ) : (
            <ContentCenterDiv>
              <br></br>
              <Pagination
                showSizeChanger={false}
                current={page + 1}
                total={roleListData?.count}
                onChange={onPageChange}
                defaultCurrent={0}
              />
              <br></br>
            </ContentCenterDiv>
          )}
        </RightDivCol>
      </Row>
    </SectionWrapper>
  )
}
export default Roles
